<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Manutenção</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onCreate()" v-b-tooltip title="Cadastrar"
                      ><i class="ft-plus"></i
                    ></a>
                  </li>
                  <!-- <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-down"></i></a></li> -->
                  <li>
                    <a
                      @click="onCreateRespacho()"
                      v-if="
                        this.$refs.vuetable &&
                        this.$refs.vuetable.selectedTo.length > 0
                      "
                      v-b-tooltip
                      title="Cadastrar Motorista Redespacho"
                      ><i class="fa fa-truck"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onCreateModalidadeFrete()"
                      v-if="
                        this.$refs.vuetable &&
                        this.$refs.vuetable.selectedTo.length > 0
                      "
                      v-b-tooltip
                      title="Cadastrar Modalidade de Frete"
                      ><i class="fa fa-truck"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onImportXml()"
                      v-b-tooltip
                      title="Importar XML NFe"
                      v-if="getPermissionFw('xmlnfe.import')"
                      ><i class="fa fa-code step-xml-nfe"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onImportXmlCte()"
                      v-b-tooltip
                      title="Importar XML CTe"
                      v-if="getPermissionFw('xmlcte.import')"
                      ><i class="fa fa-codepen step-xml-cte"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/docfiscal"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    :load-on-start="false"
                    track-by="docfis_id"
                    pagination-path=""
                    detail-row-component="manutencaonotas-detalhes"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="dt_emissao" slot-scope="props">
                      <span>{{ formatDate(props.rowData.dt_emissao) }}</span>
                    </template>
                    <template slot="emissor" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.emi_cnpj != null
                        "
                        >{{
                          ajustaMascara(
                            props.rowData.doc_fiscal_partes_env.emi_cnpj,
                            2
                          )
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.emi_cpf != null
                        "
                        >{{
                          ajustaMascara(
                            props.rowData.doc_fiscal_partes_env.emi_cpf,
                            1
                          )
                        }}</span
                      >
                    </template>

                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.liv_status_importacao.valor == 1"
                        >{{ props.rowData.liv_status_importacao.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.liv_status_importacao.valor == 2"
                        >{{ props.rowData.liv_status_importacao.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <a
                          v-if="props.rowData.status.valor == 2"
                          @click="onActivateDesactivate(1, props.rowData, true)"
                          v-b-tooltip
                          title="Ativar"
                          ><i class="fa fa-thumbs-o-up"></i
                        ></a>
                        <a
                          v-if="props.rowData.status.valor == 1"
                          @click="onActivateDesactivate(2, props.rowData, true)"
                          v-b-tooltip
                          title="Inativar"
                          ><i class="fa fa-thumbs-o-down"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Component -->
      <b-modal
        id="modal_upload_xml"
        ref="modal_upload_xml"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        v-model="showModalXml"
      >
        <div class="col-md-12 col-sm-12">
          <label>Importar XML de NFe </label>
          <b-form-file
            v-model="form.file"
            :state="Boolean(form.file)"
            placeholder="Selecione ou arraste o arquivo aqui"
            drop-placeholder="Solte aqui"
          ></b-form-file>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="float-right">
            <b-btn
              @click="onStoreNfe()"
              variant="secondary"
              :disabled="isDisabled"
            >
              Enviar
            </b-btn>
            <b-btn @click="showModalXml = false" variant="secondary">
              Fechar
            </b-btn>
          </div>
        </div>
      </b-modal>

      <!-- Modal Component -->
      <b-modal
        id="modal_upload_xml_cte"
        ref="modal_upload_xml_cte"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        v-model="showModalXmlCTe"
      >
        <div class="col-md-12 col-sm-12">
          <label>Importar XML de CTe </label>
          <b-form-file
            v-model="form.file"
            :state="Boolean(form.file)"
            placeholder="Selecione ou arraste o arquivo aqui"
            drop-placeholder="Solte aqui"
          ></b-form-file>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="float-right">
            <b-btn
              @click="onStoreCte()"
              variant="secondary"
              :disabled="isDisabled"
            >
              Enviar
            </b-btn>
            <b-btn @click="showModalXmlCTe = false" variant="secondary">
              Fechar
            </b-btn>
          </div>
        </div>
      </b-modal>

      <ManutencaoNotaFiscal ref="manutencaonotafiscal" />
      <ManutencaoNotaFiscalRedespachoModal
        ref="manutencaonotafiscalredespachomodal"
      />
      <ManutencaoNotaFiscalModallidadeFrete
        ref="manutencaonotafiscalmodallidadefrete"
        :metodo="onFilterReset"
      />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import ManutencaoNotaFiscal from "./ManutencaoNotaFiscalForm.vue";
import ManutencaoNotaFiscalFilterBar from "./ManutencaoNotaFiscalFilterBar.vue";
import UnidadeDetalhes from "./UnidadeDetalhes.vue";
import ManutencaoNotaFiscalDetalhes from "./ManutencaoNotaFiscalDetalhes.vue";
import ManutencaoNotaFiscalRedespachoModal from "./ManutencaoNotaFiscalRedespachoModal.vue";
import ManutencaoNotaFiscalModallidadeFrete from "./ManutencaoNotaFiscalModallidadeFrete.vue";

Vue.component("manutencaonotas-detalhes", ManutencaoNotaFiscalDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ManutencaoNotaFiscal,
    ManutencaoNotaFiscalDetalhes,
    ManutencaoNotaFiscalModallidadeFrete,
    ManutencaoNotaFiscalRedespachoModal,
    "vuetable-filterbar": ManutencaoNotaFiscalFilterBar,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: false,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      showModalXml: false,
      showModalXmlCTe: false,
      isFullscreen: false,
      livGeralLoaded: false,
      data: [],
      optionsTpPessoa: [],
      optionsTpDocFiscal: [],
      optionsMunicipios: [],
      optionsUf: [],
      optionsStatusImportacao: [],
      optionsModalidadeFrete: [],
      optionsTipoCarga: [],
      form: new FileForm({
        file: null,
        data: [],
      }),
      form1: new Form({
        docfis: [],
      }),
      //número da nota, serie da nota, data de emissão da nota, emissor da nota e unidade da nota fiscal tb pf
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "Número da nota",
          sortField: "num_fiscal",
        },
        {
          name: "serie",
          title: "Serie da Nota",
          sortField: "serie",
        },
        {
          name: "__slot:dt_emissao",
          title: "Data de emissão",
          sortField: "dt_emissao",
        },
        {
          name: "doc_fiscal_partes_env.emi_nome",
          title: "Emissor",
        },
        {
          name: "__slot:emissor",
          title: "Cnpj - Emissor",
          sortField: "emissor",
        },
        {
          name: "unidade_nota",
          title: "Unidade da Nota fiscal",
          sortField: "unidade_nota",
        },
        {
          name: "num_lote",
          title: "N° Lote",
          sortField: "num_lote",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
    this.livGeralLoaded = true;
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        nf_ini: data_filter.nf_ini,
        nf_fim: data_filter.nf_fim,
        serie: data_filter.serie,
        emi_razao_social: data_filter.emi_razao_social,
        red_razao_social: data_filter.red_razao_social,
        usuario_imp: data_filter.usuario_imp,
        dt_imp_ini: data_filter.dt_imp_ini,
        hr_imp_ini: data_filter.hr_imp_ini,
        dt_imp_fim: data_filter.dt_imp_fim,
        hr_imp_fim: data_filter.hr_imp_fim,
        dt_inicio: data_filter.dt_emi_ini,
        dt_fim: data_filter.dt_emi_fim,
        emi_cnpj: data_filter.emi_cnpj,
        des_cnpj: data_filter.des_cnpj,
        chave: data_filter.chave,
        status: data_filter.status,
        tp_pessoa: data_filter.tp_pessoa,
        municipio: data_filter.municipio,
        status_importacao: data_filter.status_importacao.value,
        fornecedor: data_filter.fornecedor,
      };
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.moreParams = {};
      this.loadingData = false;
      Vue.nextTick(() => {
        this.$refs.vuetable.tableData = [];
        this.$refs.vuetable.tablePagination = null;
        this.$refs.pagination.setPaginationData({
          current_page: 0,
          last_page: 0,
          total: 0,
          per_page: 0,
          from: 0,
          to: 0,
        });
        this.$refs.paginationInfo.setPaginationData({
          current_page: 0,
          last_page: 0,
          total: 0,
          per_page: 0,
          from: 0,
          to: 0,
        });
      });
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        if (!this.livGeralLoaded) {
          this.getLivGeral();
          this.livGeralLoaded = true;
        }
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      console.log(data);
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.docfis_id);
      }
    },
    onCreate() {
      this.$refs.manutencaonotafiscal.onCreate();
    },
    onEdit(data, index) {
      this.$refs.manutencaonotafiscal.onEdit(data);
    },
    onCreateRespacho(data) {
      this.form1.docfis = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form1.docfis.push({ docfis_id: obj });
      });
      data = this.form1.docfis;
      this.$refs.manutencaonotafiscalredespachomodal.onCreate(data);
      this.$refs.vuetable.selectedTo = [];
    },
    onCreateModalidadeFrete(data) {
      this.form1.docfis = [];
      this.$refs.vuetable.selectedTo.forEach(obj => {
        this.form1.docfis.push(obj);
      });
      data = this.form1.docfis;
      this.$refs.manutencaonotafiscalmodallidadefrete.onCreate(data);
      // this.$refs.vuetable.selectedTo = [];
    },
    onReloadVuetable() {
      if (Object.keys(this.moreParams).length === 0) {
        return;
      }
      this.$refs.vuetable.reload();
    },
    onImportXml(data) {
      this.modal_titulo = "Importar XML de NFe";
      this.modal_botao = "Importar";
      this.modal_acao = "i";
      this.loading = false;
      this.isDisabled = false;
      this.$refs.modal_upload_xml.show();
    },
    onStoreNfe() {
      this.loading = true;
      this.isDisabled = true;
      this.data.push({ label: "file", value: this.form.file });
      this.form.data = this.data;
      this.form
        .upload("/api/xmlnfe")
        .then((response) => {
          new ReturnApi(response, this, null, true);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onImportXmlCte(data) {
      this.modal_titulo = "Importar XML de CTe";
      this.modal_botao = "Importar";
      this.modal_acao = "i";
      this.loading = false;
      this.isDisabled = false;
      this.$refs.modal_upload_xml_cte.show();
    },
    onStoreCte() {
      this.loading = true;
      this.isDisabled = true;
      this.data.push({ label: "file", value: this.form.file });
      this.form.data = this.data;
      this.form
        .upload("/api/xmlcte")
        .then((response) => {
          new ReturnApi(response, this, null, true);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    handleOkDoc(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStoreDoc();
      } else {
        this.onUpdateDoc(this.formdoc.unidoc_id);
      }
    },
    handleOkConta(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStoreConta();
      } else {
        this.onUpdateConta(this.form_conta.unicon_id);
      }
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/docfiscal/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/docfiscal/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/docfiscal/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);

          response.tp_pessoa.forEach((obj) => {
            this.optionsTpPessoa.push({
              text: obj.descr,
              value: obj.valor,
            });
          }),
            response.doc_fiscal_tp_doc.forEach((obj) => {
              this.optionsTpDocFiscal.push({
                label: obj.descr,
                value: obj.valor,
              });
            }),
            response.municipios.forEach((obj) => {
              this.optionsMunicipios.push({
                label: obj.nome + ' - ' + obj.uf.cd,
                value: obj.municipio_id,
                ibge: obj.cd_ibge,
              });
            });
            response.uf.forEach((obj) => {
              this.optionsUf.push({
                label: obj.cd,
                value: obj.uf_id,
              });
            });
          response.modalidade_frete.forEach((obj) => {
            this.optionsModalidadeFrete.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tipo_carga.forEach((obj) => {
            this.optionsTipoCarga.push({
              label: obj.descr,
              value: obj.tpcarga_id,
            });
          });
          response.status_importacao.forEach((obj) => {
            this.optionsStatusImportacao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.docfis_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.manutencaonotafiscal.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    ajustaMascara(data, tipo) {
      if (tipo === 1) {
        //cpf
        return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (tipo === 2) {
        //cnpj
        return data.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
